module.exports = __webpack_public_path__ + "img/2_246.49793f8c.png";